export interface FloaterDimensions {
  left: string;
  top: string;
  width: string;
  height: string;
}

export const adjustFloaterPosition = (initialPosition: {
  left: number;
  top: number;
  width: number;
  height: number;
}): FloaterDimensions => {
  const { left, top, width, height } = initialPosition;
  const viewportWidth = window.innerWidth;

  const floaterLeft = left;
  const floaterTop = top;
  let floaterWidth = width;
  let floaterHeight = height;

  if (floaterWidth + 16 > viewportWidth) {
    floaterWidth -= 16; /*                                      */
  }

  if (floaterTop < 0) {
    floaterHeight -= 16; /*                                       */
  }

  return {
    left: `${floaterLeft}px`,
    top: `${floaterTop}px`,
    width: `${floaterWidth}px`,
    height: `${floaterHeight}px`,
  };
};

export const checkIfFloaterExceedsViewport = (floater: HTMLElement): boolean => {
  const floaterBoundings = floater.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  return (
    floaterBoundings.left <= 0 ||
    floaterBoundings.top <= 0 ||
    floaterBoundings.right >= viewportWidth ||
    floaterBoundings.bottom >= viewportHeight
  );
};

const getFloaterPosition = (target: HTMLElement): FloaterDimensions => {
  const computedStyle = getComputedStyle(target);
  const { outlineOffset } = computedStyle;

  const padding = parseFloat(outlineOffset || "0px");
  const { width, height, left, top } = target.getBoundingClientRect();

  if (checkIfFloaterExceedsViewport(target)) {
    return adjustFloaterPosition({
      left: left + window.scrollX + width / 2,
      top: top + window.scrollY + height / 2,
      width: width + padding * 2,
      height: height + padding * 2,
    });
  }

  return {
    left: `${left + window.scrollX + width / 2}px`,
    top: `${top + window.scrollY + height / 2}px`,
    width: `${width + padding * 2}px`,
    height: `${height + padding * 2}px`,
  };
};

export const repositionElement = (floater: HTMLElement, target: HTMLElement): void => {
  const styles = getFloaterPosition(target);
  Object.assign(floater.style, styles);
};
